import { render, staticRenderFns } from "./main-recruitment-list.vue?vue&type=template&id=2bb2737e"
import script from "./main-recruitment-list.vue?vue&type=script&lang=js"
export * from "./main-recruitment-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports